import axios from 'axios';
import getCookie from '@helpers/getCookie';
import setCookie from '@helpers/setCookie';
import sha256 from 'crypto-js/sha256';
import CryptoJS from 'crypto-js';
import dateDiff from '@helpers/dateDiff';
import moment from 'moment';
const USER_SECRET = 'W3@Cont3ntMeg@al';

const UserApi = {};

UserApi.get = (force) => {
  return new Promise((resolve, reject) => {
    if (!getCookie('token')) {
      if (sessionStorage.getItem('User')) {
        sessionStorage.removeItem('User');
        sessionStorage.removeItem('TokenGA');
        const pg = window.location.pathname
        window.location.href = `/login?returnPath=${pg}`;
        if (pg === '/login' || pg === '/cadastro') {
          window.location.href = '/login?returnPath=/'
        }
      }
      const eventUserReload = new CustomEvent('user:reload', { detail: null });
      window.dispatchEvent(eventUserReload);
      return resolve(null);
    }

    if (!force && !!sessionStorage.getItem('User')) {
      const userdecripted = CryptoJS.AES.decrypt(sessionStorage.getItem('User'), USER_SECRET).toString(CryptoJS.enc.Utf8);
      const user = JSON.parse(userdecripted).user;
      if (!user.antiFraude) {
        user.antiFraude = true;
        const userEncripted = CryptoJS.AES.encrypt(JSON.stringify({ user }), USER_SECRET).toString();

        sessionStorage.setItem('User', userEncripted);
        sessionStorage.setItem('TokenGA', user.userID);
      }
      // atualiza user a cada 1 min
      if (user && user.last_update && Date.now() - user.last_update < 60000) { return resolve(user); }
    }

    axios
      .get('/rest/user')
      .then((res) => {
        if (res.data) {
          res.data.last_update = Date.now();
          res.data.hashID = sha256(res.data.UserID).toString();
          res.data.antiFraude = false;
          const createdOnDate = res.data.createdOnDate;
          const lastBuyDate = res.data.lastBuyDate;
          const userEncripted = CryptoJS.AES.encrypt(JSON.stringify({ user: res.data }), USER_SECRET).toString();
          sessionStorage.setItem('User', userEncripted);
          sessionStorage.setItem('TokenGA', res.data.userID);

          const today = moment().endOf('day')
          const diffCreate = createdOnDate != null ? dateDiff(today, new Date(createdOnDate)) : 0;
          const diffBuy = lastBuyDate != null ? dateDiff(today, new Date(lastBuyDate)) : 30;

          localStorage.setItem('createdOnDays', diffCreate);
          localStorage.setItem('lastPurchaseDays', diffBuy);
        } else {
          if (sessionStorage.getItem('User')) {
            sessionStorage.removeItem('User');
            sessionStorage.removeItem('TokenGA');
          }
        }

        const eventUserReload = new CustomEvent('user:reload', {
          detail: res.data
        });
        window.dispatchEvent(eventUserReload);

        return resolve(res.data);
      })
      .catch((err) => {
        if (sessionStorage.getItem('User')) {
          sessionStorage.removeItem('User');
          sessionStorage.removeItem('TokenGA');
        }

        if (err.response.status == 401 && getCookie('token')) {
          setCookie('token', '');
        }

        const eventUserReload = new CustomEvent('user:reload', { detail: null });
        window.dispatchEvent(eventUserReload);
        return reject(
          err && err.response && err.response.data ? err.response.data : null
        );
      });
  });
};

UserApi.reload = function () {
  return UserApi.get(true);
};

UserApi.update = function (data) {
  if (!data) {
    return;
  }

  return new Promise((resolve, reject) => {
    axios
      .put('/rest/user', data)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(
          err && err.response && err.response.data ? err.response.data : (err || null)
        );
      });
  });
};

UserApi.updatePassword = function (data) {
  return new Promise((resolve, reject) => {
    axios
      .post('/rest/user/update-password', data)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(
          err && err.response && err.response.data ? err.response.data : null
        );
      });
  });
};

UserApi.login = (data) => {
  if (sessionStorage.getItem('User')) {
    sessionStorage.removeItem('User');
  }

  return new Promise((resolve, reject) => {
    axios
      .post('/rest/user/login', data)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(
          err && err.response && err.response.data ? err.response.data : null
        );
      });
  });
};

UserApi.loginSocial = (provider, token) => {
  if (sessionStorage.getItem('User')) {
    sessionStorage.removeItem('User');
  }

  return new Promise((resolve, reject) => {
    axios
      .get(
        `/rest/user/login-social?provider=${provider}&externalAccessToken=${token}`
      )
      .then((res) => {
        return resolve(res.data);
      })
      .catch(() => {
        return reject(new Error());
      });
  });
};
UserApi.confirmForgotCode = (userID, code) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/rest/user/validate-verification-code', { userID: userID, code: code })
      .then((res) => {
        return resolve(res.status);
      })
      .catch((err) => {
        return reject(
          err && err.response && err.response.data ? err.response.data : null
        );
      });
  });
};
UserApi.forgotCode = (userID, deliveryChannel) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/rest/user/send-verification-code', { userID: userID, deliveryChannel: deliveryChannel })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(
          err && err.response && err.response.data ? err.response.data : null
        );
      });
  });
};

UserApi.recoverAccess = (username) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/rest/user/recover-access', { username: username })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(
          err && err.response && err.response.data ? err.response.data : null
        );
      });
  });
};
UserApi.forgot = (username) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/rest/user/forgot', { username: username })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(
          err && err.response && err.response.data ? err.response.data : null
        );
      });
  });
};
UserApi.sendComprovante = (orderId, base64File) => {
  return axios({
    method: 'post',
    url: `/rest/user/order/${orderId}/comprovante`,
    data: base64File,
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

UserApi.sendSupportFormAttachment = (base64File) => {
  return axios({
    method: 'post',
    url: '/rest/user/support-form/upload-attachment',
    data: base64File,
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

UserApi.getPaymentInfo = (orderId) => {
  return new Promise((resolve, reject) =>
    axios
      .get(`/rest/user/get-payment-info/${orderId}`)
      .then((result) => resolve(result.data))
      .catch((err) =>
        reject(
          err && err.response && err.response.data ? err.response.data : null
        )
      )
  );
};

UserApi.telesenaComprovante = (orderId, token) => {
  return axios({
    method: 'get',
    url: `/rest/checkout/telesena-receipt/${orderId}`,
    headers: {
      token,
      'Content-Type': 'text/plain'
    }
  });
};

UserApi.register = async (data) => {
  try {
    return await axios
      .post('/rest/user/register', data)
      .then((res) => res.data)
  } catch (err) {
    throw err && err.response && err.response.data ? err.response.data : null
  }
};

UserApi.getCards = () => {
  return new Promise((resolve, reject) => {
    axios
      .get('/rest/user/cards')
      .then((res) => {
        return resolve(res.data);
      })
      .catch(() => {
        return reject(new Error());
      });
  });
};

UserApi.getAccounts = () => {
  return new Promise((resolve, reject) => {
    axios
      .get('/rest/user/bank-accounts')
      .then((res) => {
        return resolve(res.data);
      })
      .catch(() => {
        return reject(new Error());
      });
  });
};

UserApi.deleteAccount = (password) => {
  return new Promise((resolve, reject) => {
    axios
      .put('/rest/user/delete', {
        password: password
      })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(
          err && err.response && err.response.data ? err.response.data : null
        );
      });
  });
};

UserApi.cancelRecurrence = (recurrencingPaymentId) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/rest/user/cancel-recurrence/${recurrencingPaymentId}`)
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(
          err && err.response && err.response.data ? err.response.data : null
        );
      });
  });
};

UserApi.subscribeEbook = (email, fullName, phoneNumber) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/rest/user/subscribe-ebook', {
        portalID: 1,
        email,
        fullName,
        phoneNumber
      })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(err && err.response && err.response.data ? err.response.data : null);
      });
  });
};

export default UserApi;
